export default "__VITE_ASSET__d588982f__"